module.exports = __webpack_public_path__ + "img/广昌县人民医院.0f4d0e15.png";